import elementOfType from './validators/elementOfType';
import tuple from './validators/tuple';
export default {
  elementOfType: elementOfType,
  tuple: tuple
};